require('./scheduleController');
require('./scheduleSearch/scheduleSearchDirective');
require('./noBroadcast/noBroadcastDirective');
require('./gameActions/gameActionsDirective');
require('./scheduleGame/scheduleGameDirective');
require('./favoriteGame/favoriteGameDirective');
require("../shared/favoritesCarousel/favoritesCarouselDirective");

"use strict";

angular.module('app.schedule.scheduleDirective', [
  'app.schedule.scheduleController',
  'app.schedule.scheduleSearch.scheduleSearchDirective',
  'app.schedule.noBroadcastDirective',
  'app.schedule.gameActions.gameActionsDirective',
  'app.schedule.favoriteGame.favoriteGameDirective',
  'app.schedule.scheduleGame.scheduleGameDirective',
  'app.shared.favoritesCarousel.favoritesCarouselDirective'
])
    .directive('schedule', [
      function () {
        return {
          restrict: 'E',
          templateUrl: 'components/schedule/scheduleDirectiveView.html',
          controller: 'app.schedule.scheduleController',
          scope: {
            searchInclude: '<',
            searchHideDateSelector: '<',
            searchHide: '<',
            searchHideTerm: '<?',
            searchTerm: '<',
            searchName: '<?',
            scheduleType: '@',
            broadcastActive: '<',
            limitToFavorites: '<'
          },
          link: function (scope, elm) {
            elm.addClass('schedule-directive');
          }
        };
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/scheduleDirective.js